export const ROOM_DETAIL_QUERY = 'viewRoomDetail';
export const PLAN_DETAIL_QUERY = 'viewPlanDetail';
export const SUGGESTED_MEDIA_COUNT = 1;
export const SUGGESTED_FEATURE_COUNT = 0;
export const DEFAULT_BED_AMOUNT = 1;
